export class LinkedListNode {
    constructor(value) {
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    insertAfter(value) {
        const node = new LinkedListNode(value);
        node.prev = this;
        node.next = this.next;
        if (this.next) {
            this.next.prev = node;
        }
        this.next = node;
        return node;
    }
    insertBefore(value) {
        const node = new LinkedListNode(value);
        node.prev = this.prev;
        node.next = this;
        if (this.prev) {
            this.prev.next = node;
        }
        this.prev = node;
        return node;
    }
    remove() {
        if (this.prev) {
            this.prev.next = this.next;
        }
        if (this.next) {
            this.next.prev = this.prev;
        }
        this.value = undefined;
    }
    get start() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let node = this;
        while (node.prev) {
            node = node.prev;
        }
        return node;
    }
    toArray() {
        const result = [];
        let node = this.start;
        while (node) {
            result.push(node.value);
            node = node.next;
        }
        return result;
    }
}
//# sourceMappingURL=LinkedList.js.map